import {useQuery} from '@tanstack/react-query';
import {useChekinSDK} from 'context/ChekinSDK';
import {useReservation} from 'context/reservation';
import {useErrorToast} from 'hooks/common';
import {QUERY_CACHE_KEYS} from '@chekin/core';
import {API} from '@chekin/api';

function useGuestGroup() {
  const {isSuccessSDK} = useChekinSDK();
  const {data: reservation, isLoading: isLoadingReservation} = useReservation();
  const guestGroupId = reservation?.guest_group_id;

  const {data, isLoading, isFetching, error, isSuccess} = useQuery({
    queryKey: [QUERY_CACHE_KEYS.guestGroup, guestGroupId],
    queryFn: () => API.guestGroup.getGuestGroup(guestGroupId || ''),
    staleTime: 10_000,
    gcTime: 10_000,
    retryOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled: isSuccessSDK && Boolean(guestGroupId),
  });

  useErrorToast(error, {
    notFoundMessage: 'Requested guests group not found',
    onlyMounted: true,
  });

  const isLeaderGuest = data?.added_number_of_guests === 0;

  const areAllGuestsRegistered =
    (data?.known_number_of_guests ?? 0) <= (data?.added_number_of_guests ?? 0);

  const missingGuests = !data
    ? 0
    : data.known_number_of_guests - data.added_number_of_guests;

  const leaderGuest = data?.members?.find(guest => guest?.id === data?.leader_id);

  return {
    guestGroup: data,
    isLoading: isLoading || isLoadingReservation,
    isFetching: isFetching,
    isLeaderGuest,
    leaderGuest,
    areAllGuestsRegistered,
    missingGuests,
    isSuccess,
  };
}

export {useGuestGroup};
